import React from 'react';
import bag from '../../Media/woman-bag.webp'
import signs from '../../Media/signs.webp'
import medication from '../../Media/medication.webp'
import water from '../../Media/water.webp'

import p1 from '../../Media/Card/p1.jpg'
import p2 from '../../Media/Card/p2.jpg'
import p3 from '../../Media/Card/p3.webp'
import p4 from '../../Media/Card/p4.jpg'
import p5 from '../../Media/Card/p5.jpg'

import doc from '../../Media/doctor.webp'

const Section1 = () => {
    return (
        <div className='w-11/12 md:w-10/12 mx-auto'>
            <h3 className='text-2xl font-bold my-2'>Today's Top Stories</h3>
            <hr />
            <div className='md:flex items-center py-10'>
                <img src={bag} alt="" />
                <div className='md:px-10 mt-5 md:mt-0'>
                    <h3 className='md:text-5xl text-3xl font-bold mb-2 text-primary-600'>Can Money Buy You Happyness?</h3>
                    <p className='text-2xl text-gray-600'>Yes, to an extent, psychologists say, but many people don’t know how to spend for maximum happiness.</p>
                </div>
            </div>
            <hr />
            <div className='flex md:items-center justify-between my-5 md:my-10'>
                <div className='md:flex items-center'>
                    <img className='w-[225px]' src={signs} alt="" />
                    <h4 className='font-bold text-xl ml-2 md:text-3xl'>Signs of Narcissism.</h4>
                </div>
                <div className='md:flex items-center mx-2 md:mx-0'>
                    <img className='w-[225px]' src={medication} alt="" />
                    <h4 className='font-bold text-xl ml-2 md:text-3xl'>Medication Effects.</h4>
                </div>
                <div className='md:flex items-center'>
                    <img className='w-[225px]' src={water} alt="" />
                    <h4 className='font-bold text-xl ml-2 md:text-3xl'>Water You Need.</h4>
                </div>
            </div>
            <div className='flex justify-between items-center text-primary-600'>
                <h3 className='text-2xl font-bold my-2'>Living Healthy</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />
            <table className='md:flex flex-row mt-5 md:my-10'>
                <div className='mx-1 mb-8'>
                    <img src={p1} alt="" />
                    <h3 className='text-2xl font-bold my-2'>Mental Health</h3>
                </div>
                <div className='mx-1 mb-8'>
                    <img src={p2} alt="" />
                    <h3 className='text-2xl font-bold my-2'>Diet & Weight Management</h3>
                </div>
                <div className='mx-1 mb-8'>
                    <img src={p3} alt="" />
                    <h3 className='text-2xl font-bold my-2'>Healthy Aging</h3>
                </div>
                <div className='mx-1 mb-8'>
                    <img src={p4} alt="" />
                    <h3 className='text-2xl font-bold my-2'>Relationships Resource</h3>
                </div>
                <div className='mx-1 mb-8'>
                    <img src={p5} alt="" />
                    <h3 className='text-2xl font-bold my-2'>Fitness & Exercise</h3>
                </div>
            </table>
            <div className='flex justify-between items-center text-primary-600'>
                <h3 className='text-2xl font-bold mb-2'>Conditions</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div class="relative overflow-x-auto">
                <table class="w-full text-left">
                    <tbody>
                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Skin Problems
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Digestive Disorders
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Pain Management
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Diabetes
                                </div>
                            </td>
                        </tr>
                        <tr class="bg-white border-b">

                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Brain & Nervous System
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Heart Disease
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Cancer
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <div className=' flex items-center whitespace-nowrap'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary-600">
                                        <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                    </svg>
                                    Sexual Health
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Health News</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />

            <div className='md:flex items-center my-5 md:my-10'>
                <img src={doc} alt="" />
                <div className='md:px-5'>
                    <h3 className='md:text-5xl text-3xl font-bold mb-3 text-primary-600'>Medical Gaslighting: When the Doctor Dismisses Your Concerns</h3>
                    <p className='text-2xl text-gray-600'>While you may have felt your doctor was downplaying your symptoms, saying you experienced gaslighting may not be so accurate.</p>
                </div>
            </div>

            <div className='flex justify-between items-center text-primary-600 mt-8'>
                <h3 className='text-2xl font-bold my-2'>Special Section</h3>
                <p className='text-xl'>See All</p>
            </div>
            <hr />
        </div>
    );
};

export default Section1;